import React, { useState, useEffect } from 'react';
import { updateLead } from '../../services/AdminLeadService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import LeadEditForm from '../../forms/leads/LeadEditForm';
import '../../styles/AdminModal.css';

const LeadEditModal = ({
  isOpen,
  onClose,
  onSuccess,
  lead
}) => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    message: '',
    service: '',
    status: 'new',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isFormValid =
    formData.full_name.trim() !== '' &&
    formData.email.trim() !== '';

  const hasChanges =
    lead &&
    (lead.get_full_name !== formData.full_name ||
      lead.email !== formData.email ||
      (lead.message || "") !== (formData.message || "") ||
      (lead.service || "") !== (formData.service || "") ||
      lead.status !== formData.status
      );

  useEffect(() => {
    if (lead && isOpen) {
      setFormData({
        full_name: lead.get_full_name || '',
        email: lead.email || '',
        message: lead.message || '',
        service: lead.service || '',
        status: lead.status || 'new',
      });
      setErrors({});
      setError('');
    }
  }, [lead, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSave = async () => {
    setLoading(true);
    setErrors({});
    setError('');
    try {
    const dataToSave = {
      first_name: formData.full_name.split(' ')[0] || '',
      last_name: formData.full_name.split(' ').slice(1).join(' ') || '',
      email: formData.email,
      message: formData.message,
      service: formData.service,
      status: formData.status,
    };
      await updateLead(lead.id, dataToSave);
      await onSuccess();
    } catch (error) {
      
      if (error.response && error.response.data) {
        setError(error.response.data.error || 'Error updating lead. Please try again.');
      } else {
        setError('Error updating lead. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Edit Lead</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
        <div className="admin__modal-body">
          <LeadEditForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
          />
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Saving...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleSave} disabled={loading || !isFormValid || !hasChanges}>
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadEditModal;